import { render } from "./Gizlilik.vue?vue&type=template&id=70ecdd54"
import script from "./Gizlilik.vue?vue&type=script&lang=js"
export * from "./Gizlilik.vue?vue&type=script&lang=js"

import "./Gizlilik.vue?vue&type=style&index=0&id=70ecdd54&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__